import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'Valentina',
  city: 'Buenos Aires',
  img: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  name: 'Sofía',
  city: 'Córdoba',
  img: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Rocío',
  city: 'Rosario',
  img: 'https://randomuser.me/api/portraits/women/65.jpg'
}, {
  name: 'Florencia',
  city: 'Mendoza',
  img: 'https://randomuser.me/api/portraits/women/50.jpg'
}, {
  name: 'Camila',
  city: 'La Plata',
  img: 'https://randomuser.me/api/portraits/women/33.jpg'
}, {
  name: 'Romina',
  city: 'Tucumán',
  img: 'https://randomuser.me/api/portraits/women/21.jpg'
}, {
  name: 'Martín',
  city: 'Santa Fe',
  img: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  name: 'Luciana',
  city: 'Mar del Plata',
  img: 'https://randomuser.me/api/portraits/women/12.jpg'
}, {
  name: 'Agustina',
  city: 'Salta',
  img: 'https://randomuser.me/api/portraits/women/75.jpg'
}, {
  name: 'Diego',
  city: 'Neuquén',
  img: 'https://randomuser.me/api/portraits/men/45.jpg'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    }, 5000);
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % buyers.length);
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    }, 20000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  const currentBuyer = buyers[currentIndex];
  return <AnimatePresence data-id="element-191">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 40,
      x: -10
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white border border-gray-200 rounded-lg shadow-xl px-3 py-2.5 flex items-center gap-3 max-w-[280px]" data-id="element-192">
          <img src={currentBuyer.img} alt={currentBuyer.name} className="w-9 h-9 rounded-full object-cover shrink-0 border border-gray-100" data-id="element-193" />
          <div className="min-w-0" data-id="element-194">
            <p className="text-xs text-gray-800 leading-snug" data-id="element-195">
              <span className="font-bold text-gray-900" data-id="element-196">
                {currentBuyer.name}
              </span>{' '}
              de {currentBuyer.city} compró el{' '}
              <span className="font-bold text-emerald-600" data-id="element-197">Pack PRO</span> 🎉
            </p>
            <p className="text-[10px] text-gray-400 mt-0.5" data-id="element-198">
              Hace unos minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}